import tmpl from './Landing.jsx';
import withPreview from '../../hoc/WithPreview/WithPreview.js';

const Landing = () => tmpl();

export default withPreview(Landing);
